import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 2rem;
`;

export const FieldsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
`;

export const ButtonsContainer = styled.div`
  width: 90%;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 2rem;
`;
